var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5153 5.26528L6.76528 9.01528C6.73045 9.05014 6.68909 9.0778 6.64357 9.09667C6.59804 9.11555 6.54925 9.12526 6.49996 9.12526C6.45068 9.12526 6.40189 9.11555 6.35636 9.09667C6.31084 9.0778 6.26948 9.05014 6.23465 9.01528L2.48465 5.26528C2.41429 5.19491 2.37476 5.09948 2.37476 4.99996C2.37476 4.90045 2.41429 4.80502 2.48465 4.73465C2.55502 4.66429 2.65045 4.62476 2.74996 4.62476C2.84948 4.62476 2.94491 4.66429 3.01528 4.73465L6.49996 8.21981L9.98465 4.73465C10.0195 4.69981 10.0609 4.67217 10.1064 4.65332C10.1519 4.63446 10.2007 4.62476 10.25 4.62476C10.2992 4.62476 10.348 4.63446 10.3936 4.65332C10.4391 4.67217 10.4804 4.69981 10.5153 4.73465C10.5501 4.76949 10.5778 4.81086 10.5966 4.85638C10.6155 4.9019 10.6252 4.95069 10.6252 4.99996C10.6252 5.04924 10.6155 5.09803 10.5966 5.14355C10.5778 5.18907 10.5501 5.23044 10.5153 5.26528Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f3f16f0ef136a3da76bc2413ee6a3b65.svg";
export { ForwardRef as ReactComponent };